@if (placemark) {
  <div id="checklistBalloonElement" #popupElement class="statuscontainer" [class.fromMultipleMenu]="isFromMultipleMenu" [style.top.px]="position.y - 15" [style.left.px]="position.x"
    (mousewheel)="onScroll($event)" (mouseleave)="mouseLeave()" (mouseenter)="mouseEnter()">
    <div class="content">
      @if (placemark.name) {
        <div id="status_name" class="statusname">{{placemark.name}}</div>
      }
      <perfect-scrollbar class="scrollbar" [style.height.px]="tableHeight">
        @for (issue of placemark.issues; track issue; let i = $index) {
          <div>
            @if (issue != -1) {
              <div class="statusrow">
                <div class="issuesSVG">
                  <ins-layer-status-preview [label]="" [bgColor]="layer.statusColors[i]" [shape]="layer.statusShapes[i]"></ins-layer-status-preview>
                </div>
                <div class="numIssues">{{issue}}</div>
              </div>
            }
            <div class="statusrow"></div>
          </div>
        }
      </perfect-scrollbar>
    </div>
    @if (!isFromMultipleMenu) {
      <div class="arrow"></div>
    }
  </div>
}